import { classnames } from '@aibees/shared/utils';
import { Chip as ChipBase } from '@mui/material';
import { memo } from 'react';
import { Icon } from '../icon';
import { ChipContent } from './chip-content';
import type { ChipProps as Props } from './types';

export const Chip = memo(
  ({ label, startIcon, endIcon, fullWidth, ...other }: Props) => {
    return (
      <ChipBase
        className={classnames('Chip')}
        deleteIcon={<Icon name="close" size={12} />}
        icon={startIcon && <Icon name={startIcon} />}
        onClick={other.onClick}
        clickable={other.onClick ? true : other.clickable}
        label={
          <ChipContent
            // startIcon={startIcon}
            endIcon={endIcon}
            color={other.color}
            label={label}
            size={other.size}
            variant={other.variant}
          />
        }
        sx={{
          width: fullWidth ? '100%' : 'auto',
        }}
        {...other}
      />
    );
  }
);

Chip.displayName = 'Chip';
